<template>
  <div>
    <SellHeader :img_header="header_image" header="คำสั่งซื้อ" link_back="sell/orderretailcustomers"/>
    <Confirm_order_detail/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/clipboard_2.png";
import Confirm_order_detail from "@/components/admin/sell/Confirm_order_detail";
export default {
  name: "ConfirmOrderDetail",
  components: {
    Confirm_order_detail,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
